import { Button, Grid, Typography } from "@mui/material";
import React from "react";

function FailureResponse({ title, message, handleClick, ButtonName }) {
  return (
    <Grid className="container ">
      <Grid item xs={12} className="centered-div gutterBottom ">
        <Typography
          className="mb-2"
          color="error"
          variant="h6"
          sx={{ fontWeight: "bold" }}
        >
          {title}
        </Typography>
        {!!message && <Typography variant="body1" className="mb-2">
          {message}
        </Typography>}
        {!!ButtonName && <Button
          onClick={() => handleClick()}
          variant="contained"
          style={{ width: "100%" }}
        >
          {ButtonName}
        </Button>}
      </Grid>
    </Grid>
  );
}

export default FailureResponse;
